/* ==========================================================================
   Atacado Page — FAQ Accordion + Depoimentos Swiper
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  /* --------------------------------------------------------------------------
     FAQ Accordion
     -------------------------------------------------------------------------- */
  const faqItems = document.querySelectorAll('.atacado-faq-item');

  faqItems.forEach(function (item) {
    const question = item.querySelector('.atacado-faq-item__question');
    if (!question) return;

    question.addEventListener('click', function () {
      const isActive = item.classList.contains('atacado-faq-item--active');

      // Fecha todos
      faqItems.forEach(function (other) {
        other.classList.remove('atacado-faq-item--active');
      });

      // Abre o clicado (se não estava aberto)
      if (!isActive) {
        item.classList.add('atacado-faq-item--active');
      }
    });
  });

  /* --------------------------------------------------------------------------
     Depoimentos Swiper Carousel
     -------------------------------------------------------------------------- */
  const depoimentosEl = document.querySelector('.atacado-depoimentos__swiper');
  if (depoimentosEl && typeof Swiper !== 'undefined') {
    var prevBtn = document.querySelector('.atacado-depoimentos__prev');

    var depoimentosSwiper = new Swiper(depoimentosEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      navigation: {
        nextEl: '.atacado-depoimentos__next',
        prevEl: '.atacado-depoimentos__prev',
      },
      breakpoints: {
        0: {
          spaceBetween: 8,
        },
        750: {
          spaceBetween: 12,
        },
      },
      on: {
        slideChange: function () {
          if (prevBtn) {
            if (this.isBeginning) {
              prevBtn.classList.remove('is-visible');
            } else {
              prevBtn.classList.add('is-visible');
            }
          }
        },
      },
    });
  }

  /* --------------------------------------------------------------------------
     Video Play/Pause em Depoimentos
     -------------------------------------------------------------------------- */
  function toggleVideo(card) {
    var video = card.querySelector('video');
    if (!video) return;

    if (video.paused) {
      // Pausa todos os outros vídeos
      document.querySelectorAll('.atacado-depoimento-card video').forEach(function (v) {
        if (v !== video) {
          v.pause();
          v.muted = true;
          v.closest('.atacado-depoimento-card').classList.remove('atacado-depoimento-card--playing');
        }
      });
      video.muted = false;
      video.play();
      card.classList.add('atacado-depoimento-card--playing');
    } else {
      video.pause();
      video.muted = true;
      card.classList.remove('atacado-depoimento-card--playing');
    }
  }

  document.querySelectorAll('.atacado-depoimento-card--video').forEach(function (card) {
    var playBtn = card.querySelector('.atacado-depoimento-card__play');
    var video = card.querySelector('video');
    if (!video) return;

    // Play/pause pelo botão
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleVideo(card);
      });
    }

    // Play/pause clicando no card inteiro
    card.addEventListener('click', function () {
      toggleVideo(card);
    });

    video.addEventListener('ended', function () {
      video.muted = true;
      card.classList.remove('atacado-depoimento-card--playing');
    });
  });

  /* --------------------------------------------------------------------------
     Modal de Revenda — abre/fecha + envia para Google Apps Script
     -------------------------------------------------------------------------- */
  var modal = document.getElementById('atacado-formulario-modal');
  if (!modal) return;

  var form = modal.querySelector('[data-atacado-form]');
  var endpoint = modal.dataset.endpoint || '';
  var successMessage = modal.dataset.successMessage || 'Recebemos seu cadastro!';
  var errorMessage = modal.dataset.errorMessage || 'Não foi possível enviar. Tente novamente.';
  var feedback = modal.querySelector('[data-atacado-feedback]');
  var whatsappCta = modal.querySelector('[data-atacado-whatsapp]');
  var submitBtn = modal.querySelector('[data-atacado-submit]');

  /* Abrir modal a partir de qualquer botão "Quero Revender" (exceto o WhatsApp) */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.atacado-btn-revender');
    if (!trigger) return;
    event.preventDefault();
    openModal();
  });

  /* Fechar pelo botão X */
  modal.querySelectorAll('[data-atacado-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeModal();
    });
  });

  /* Fechar clicando no backdrop */
  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  /* Fechar no evento nativo de cancel (ESC) já fecha — garantimos limpeza */
  modal.addEventListener('close', function () {
    resetFeedback();
  });

  function openModal() {
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    document.body.style.overflow = 'hidden';
    var firstInput = form && form.querySelector('input:not([type="hidden"])');
    if (firstInput) {
      setTimeout(function () { firstInput.focus(); }, 50);
    }
  }

  function closeModal() {
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.body.style.overflow = '';
  }

  function resetFeedback() {
    if (whatsappCta) whatsappCta.hidden = true;
    if (!feedback) return;
    feedback.hidden = true;
    feedback.removeAttribute('data-state');
    feedback.textContent = '';
  }

  function showFeedback(state, message) {
    if (!feedback) return;
    feedback.hidden = false;
    feedback.setAttribute('data-state', state);
    feedback.textContent = message;
    if (whatsappCta) whatsappCta.hidden = state !== 'success';
  }

  /* --------------------------------------------------------------------------
     Custom Select (dropdown Revenda / Representação)
     -------------------------------------------------------------------------- */
  var selectRoot = modal.querySelector('[data-atacado-select]');
  if (selectRoot) {
    var trigger = selectRoot.querySelector('[data-atacado-select-trigger]');
    var valueEl = selectRoot.querySelector('[data-atacado-select-value]');
    var hiddenInput = selectRoot.querySelector('[data-atacado-select-input]');
    var options = selectRoot.querySelectorAll('[data-atacado-select-option]');

    function openSelect() {
      selectRoot.classList.add('atacado-select--open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeSelect() {
      selectRoot.classList.remove('atacado-select--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      if (selectRoot.classList.contains('atacado-select--open')) {
        closeSelect();
      } else {
        openSelect();
      }
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var value = opt.getAttribute('data-value') || '';
        var title = opt.querySelector('.atacado-select__option-title');
        hiddenInput.value = value;
        valueEl.textContent = title ? title.textContent : value;
        selectRoot.classList.add('atacado-select--has-value');
        options.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        opt.setAttribute('aria-selected', 'true');
        closeSelect();
      });
    });

    document.addEventListener('click', function (event) {
      if (!selectRoot.contains(event.target)) {
        closeSelect();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && selectRoot.classList.contains('atacado-select--open')) {
        closeSelect();
        trigger.focus();
      }
    });
  }

  /* --------------------------------------------------------------------------
     Máscaras vanilla (WhatsApp + CPF/CNPJ)
     -------------------------------------------------------------------------- */
  function maskWhatsapp(value) {
    var digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length === 0) return '';
    if (digits.length <= 2) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    if (digits.length <= 10) {
      return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 6) + '-' + digits.slice(6);
    }
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7);
  }

  function maskDocumento(value) {
    var digits = value.replace(/\D/g, '').slice(0, 14);
    if (digits.length <= 11) {
      // CPF 000.000.000-00
      if (digits.length <= 3) return digits;
      if (digits.length <= 6) return digits.slice(0, 3) + '.' + digits.slice(3);
      if (digits.length <= 9) return digits.slice(0, 3) + '.' + digits.slice(3, 6) + '.' + digits.slice(6);
      return digits.slice(0, 3) + '.' + digits.slice(3, 6) + '.' + digits.slice(6, 9) + '-' + digits.slice(9);
    }
    // CNPJ 00.000.000/0000-00
    return digits.slice(0, 2) + '.' + digits.slice(2, 5) + '.' + digits.slice(5, 8) + '/' + digits.slice(8, 12) + '-' + digits.slice(12);
  }

  // Helper: re-posiciona cursor pela contagem de dígitos (ignora separadores),
  // então o cursor não "pula" quando a máscara adiciona/remove pontos/traços.
  function setCursorByDigitCount(input, digitCount) {
    var value = input.value;
    var pos = 0;
    var counted = 0;
    while (pos < value.length && counted < digitCount) {
      if (/\d/.test(value.charAt(pos))) counted++;
      pos++;
    }
    input.setSelectionRange(pos, pos);
  }

  function setupMask(input, maskFn, onChange) {
    // Input: aplica máscara preservando cursor
    input.addEventListener('input', function () {
      var cursorPos = input.selectionStart || 0;
      var digitsBeforeCursor = input.value.slice(0, cursorPos).replace(/\D/g, '').length;
      input.value = maskFn(input.value);
      setCursorByDigitCount(input, digitsBeforeCursor);
      if (typeof onChange === 'function') onChange(input);
    });

    // Backspace sobre separador: apaga separador + dígito anterior em um único delete
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Backspace') return;
      if (input.selectionStart !== input.selectionEnd) return;

      var pos = input.selectionStart;
      if (pos === 0) return;
      var charBefore = input.value.charAt(pos - 1);
      if (/\d/.test(charBefore)) return;

      event.preventDefault();
      var left = input.value.slice(0, pos);
      // Remove todos os separadores no fim de `left` e um dígito adicional
      var stripped = left.replace(/\D+$/, '');
      stripped = stripped.replace(/\d$/, '');
      var newRaw = stripped + input.value.slice(pos);
      var digitsBeforeCount = stripped.replace(/\D/g, '').length;
      input.value = maskFn(newRaw);
      setCursorByDigitCount(input, digitsBeforeCount);
      if (typeof onChange === 'function') onChange(input);
    });
  }

  var whatsappInput = modal.querySelector('input[data-mask="whatsapp"]');
  if (whatsappInput) {
    setupMask(whatsappInput, maskWhatsapp);
  }

  var documentoInputMask = modal.querySelector('input[data-mask="documento"]');
  if (documentoInputMask) {
    setupMask(documentoInputMask, maskDocumento, function (input) {
      validateDocumento(input);
    });
  }

  /* --------------------------------------------------------------------------
     Validação CPF / CNPJ (dígitos verificadores oficiais)
     -------------------------------------------------------------------------- */
  function isValidCPF(digits) {
    if (digits.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(digits)) return false;

    var sum = 0;
    for (var i = 0; i < 9; i++) {
      sum += parseInt(digits.charAt(i), 10) * (10 - i);
    }
    var check1 = (sum * 10) % 11;
    if (check1 === 10) check1 = 0;
    if (check1 !== parseInt(digits.charAt(9), 10)) return false;

    sum = 0;
    for (var j = 0; j < 10; j++) {
      sum += parseInt(digits.charAt(j), 10) * (11 - j);
    }
    var check2 = (sum * 10) % 11;
    if (check2 === 10) check2 = 0;
    return check2 === parseInt(digits.charAt(10), 10);
  }

  function isValidCNPJ(digits) {
    if (digits.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(digits)) return false;

    var weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    var sum = 0;
    for (var i = 0; i < 12; i++) {
      sum += parseInt(digits.charAt(i), 10) * weights1[i];
    }
    var check1 = sum % 11;
    check1 = check1 < 2 ? 0 : 11 - check1;
    if (check1 !== parseInt(digits.charAt(12), 10)) return false;

    sum = 0;
    for (var j = 0; j < 13; j++) {
      sum += parseInt(digits.charAt(j), 10) * weights2[j];
    }
    var check2 = sum % 11;
    check2 = check2 < 2 ? 0 : 11 - check2;
    return check2 === parseInt(digits.charAt(13), 10);
  }

  function validateDocumento(input) {
    var digits = (input.value || '').replace(/\D/g, '');

    // Vazio: deixa o required cuidar
    if (digits.length === 0) {
      input.setCustomValidity('');
      return;
    }

    // Incompleto: ainda digitando
    if (digits.length < 11) {
      input.setCustomValidity('Informe um CPF (11 dígitos) ou CNPJ (14 dígitos).');
      return;
    }

    if (digits.length === 11) {
      if (!isValidCPF(digits)) {
        input.setCustomValidity('CPF inválido. Confira os números digitados.');
        return;
      }
      input.setCustomValidity('');
      return;
    }

    if (digits.length > 11 && digits.length < 14) {
      input.setCustomValidity('CNPJ incompleto. Informe os 14 dígitos.');
      return;
    }

    if (digits.length === 14) {
      if (!isValidCNPJ(digits)) {
        input.setCustomValidity('CNPJ inválido. Confira os números digitados.');
        return;
      }
      input.setCustomValidity('');
      return;
    }

    input.setCustomValidity('Documento inválido.');
  }

  // Valida ao sair do campo apenas para atualizar o estado :invalid (CSS).
  // NÃO usamos reportValidity aqui — isso re-focava o input e prendia o usuário.
  // A mensagem de erro aparece no submit via form.reportValidity().
  var documentoInput = modal.querySelector('input[data-mask="documento"]');
  if (documentoInput) {
    documentoInput.addEventListener('blur', function () {
      validateDocumento(documentoInput);
    });
  }

  /* --------------------------------------------------------------------------
     Submissão do formulário → Google Apps Script (doPost)
     -------------------------------------------------------------------------- */
  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      resetFeedback();

      // Validação nativa
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!endpoint) {
        showFeedback('error', errorMessage);
        return;
      }

      var formData = new FormData(form);
      var payload = {
        nome: (formData.get('nome') || '').toString().trim(),
        whatsapp: (formData.get('whatsapp') || '').toString().trim(),
        email: (formData.get('email') || '').toString().trim(),
        interesse: (formData.get('interesse') || '').toString().trim()
      };

      submitBtn.setAttribute('disabled', '');
      submitBtn.setAttribute('data-loading', 'true');

      // Apps Script /exec redireciona para googleusercontent.com e não envia
      // Access-Control-Allow-Origin. Usamos mode: 'no-cors' — o body chega no
      // doPost e é gravado na planilha, mas a resposta fica opaca (não dá pra
      // ler). Se o fetch não lançar erro de rede, consideramos sucesso.
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify(payload),
        redirect: 'follow'
      })
        .then(function () {
          showFeedback('success', successMessage);
          form.reset();
          if (selectRoot) {
            selectRoot.classList.remove('atacado-select--has-value');
            valueEl.textContent = valueEl.getAttribute('data-placeholder') || 'Selecione';
            if (hiddenInput) hiddenInput.value = '';
          }
        })
        .catch(function () {
          showFeedback('error', errorMessage);
        })
        .finally(function () {
          submitBtn.removeAttribute('disabled');
          submitBtn.removeAttribute('data-loading');
        });
    });
  }
});
